import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/result/card-shadow.png'
import _imports_1 from '@/assets/images/card-back.png'
import _imports_2 from '@/assets/images/result/iso-download.png'
import _imports_3 from '@/assets/images/form/line.png'
import _imports_4 from '@/assets/images/result/line2.png'
import _imports_5 from '@/assets/images/result/ico-share.svg'


const _hoisted_1 = {
  key: 0,
  class: "Result-image"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-shadow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { id: "card" }
const _hoisted_4 = { class: "card-front" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-back" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_9 = { class: "ico-download" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ico-download-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_11 = {
  key: 0,
  class: "ico-download-text"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" แตะค้างที่รูปไพ่")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("เพื่อบันทึกภาพ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("ลงมือถือ ")
const _hoisted_17 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "ico-download-text"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" แตะที่รูปไพ่")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("เพื่อบันทึกภาพ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("ลงมือถือ ")
const _hoisted_24 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "ico-scrolldown" }
const _hoisted_26 = { class: "image-silde" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "textslide" }, [
  /*#__PURE__*/_createTextVNode("เลื่อนหน้าจอ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("เพื่อดูคำทำนาย")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "line-bow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_29 = { class: "card-title" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "line-bow2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_31 = { class: "Result_detail" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "card-nextday" }, " เปิดไพ่เสริมดวงรักได้ทุกวัน พรุ่งนี้มาเล่นใหม่นะ ", -1)
const _hoisted_35 = { class: "bt_group" }
const _hoisted_36 = { class: "bt_group_inner" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "bt_group_line" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "ico-share" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })
], -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" แชร์ไพ่สุดปังไปที่ FB ")
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopupCompleted = _resolveComponent("PopupCompleted")!
  const _component_LogoSmall = _resolveComponent("LogoSmall")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_ButtonGold = _resolveComponent("ButtonGold")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Result", {'bggold':_ctx.IsGolden}])
  }, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.IsGolden)
        ? (_openBlock(), _createBlock(_component_PopupCompleted, { key: 0 }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_LogoSmall, { class: "min-h" }),
    (_ctx.Carddetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.IsIos())
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `${_ctx.APIDownload}?cardfilename=${_ctx.Carddetail.cardnumber}`,
                    target: "_blank",
                    download: "meiji-photo"
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.Carddetail.image,
                      alt: ""
                    }, null, 8, _hoisted_6)
                  ], 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.Carddetail.image
                  }, null, 8, _hoisted_7))
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (_ctx.IsIos())
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_17))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_24))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_lottie_animation, { path: "animate/slide.json" })
            ]),
            _hoisted_27
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.Carddetail.name), 1),
    _hoisted_30,
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", {
        class: "card-detail",
        innerHTML: _ctx.Carddetail.detail
      }, null, 8, _hoisted_32),
      _createElementVNode("div", {
        class: "card-subtitle",
        innerHTML: _ctx.Carddetail.subtitle 
      }, null, 8, _hoisted_33),
      _hoisted_34,
      (_ctx.IsGolden)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonGold, {
                class: "pd10",
                "button-data": { name: 'กรอกข้อมูลเพื่อลุ้นรับรางวัล', width: 'auto' }
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("button", {
          class: _normalizeClass(["bt-content", { active: _ctx.btActive }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ShareFB && _ctx.ShareFB(...args)))
        }, _hoisted_40, 2)
      ])
    ])
  ], 2))
}